import React, { useState, useEffect, useRef } from 'react';
import { apiFetch } from './api';

const TaskDropdown = ({ selectedTaskId, selectedTaskName, onSelect }) => {
  const [offen, setOffen] = useState(false);
  const [hierarchie, setHierarchie] = useState([]);
  const [gewaehltesMutter, setGewaehltesMutter] = useState(null);
  const [gewaehltessProjekt, setGewaehltessProjekt] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const lade = async () => {
      const res = await apiFetch('/zeit/hierarchie');
      const data = await res.json();
      setHierarchie(data);
    };
    if (offen && hierarchie.length === 0) lade();
  }, [offen]);

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOffen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const oeffnen = () => {
    setOffen(!offen);
    setGewaehltesMutter(null);
    setGewaehltessProjekt(null);
  };

  const auswaehlen = (task, projekt, mutter) => {
    onSelect(task.id, task.name, projekt.name, mutter.name);
    setOffen(false);
    setGewaehltesMutter(null);
    setGewaehltessProjekt(null);
  };

  const typLabel = (typ) => {
    if (typ === 'produktion') return 'Prod.';
    if (typ === 'format') return 'Entw.';
    if (typ === 'backoffice') return 'Büro';
    return typ;
  };

  const spalteStyle = {
    width: '200px', flexShrink: 0, overflowY: 'auto', maxHeight: '320px',
    borderRight: '1px solid #f0f0ee'
  };

  const zeilenStyle = (aktiv, farbe) => ({
    padding: '8px 12px', fontSize: '13px', cursor: 'pointer',
    backgroundColor: aktiv ? (farbe ? `${farbe}22` : '#f0f0ee') : 'transparent',
    color: '#1a1a1a', display: 'flex', alignItems: 'center', gap: '8px',
    borderLeft: aktiv && farbe ? `3px solid ${farbe}` : '3px solid transparent',
  });

  const projekte = gewaehltesMutter ? gewaehltesMutter.projekte : [];
  const tasks = gewaehltessProjekt ? gewaehltessProjekt.tasks : [];

  return (
    <div ref={containerRef} style={{ position: 'relative', width: '100%' }}>
      <div onClick={oeffnen} style={{
        padding: '10px 14px', fontSize: '14px', border: '1px solid #e8e8e8',
        borderRadius: '8px', cursor: 'pointer', backgroundColor: '#ffffff',
        color: selectedTaskId ? '#1a1a1a' : '#9b9b9b',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {selectedTaskName || 'Task auswählen...'}
        </span>
        <span style={{ color: '#c4c4c4', fontSize: '11px', marginLeft: '8px' }}>▼</span>
      </div>

      {offen && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, zIndex: 200,
          backgroundColor: '#ffffff', border: '1px solid #e8e8e8', borderRadius: '10px',
          boxShadow: '0 8px 28px rgba(0,0,0,0.12)',
          display: 'flex', minWidth: '600px'
        }}>
          <div style={{ ...spalteStyle, borderRight: '1px solid #f0f0ee' }}>
            <div style={{ padding: '8px 12px', fontSize: '10px', fontWeight: '600', color: '#c4c4c4', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #f0f0ee' }}>
              Bereich
            </div>
            {hierarchie.map(m => (
              <div
                key={`${m.typ}-${m.id}`}
                onClick={() => { setGewaehltesMutter(m); setGewaehltessProjekt(null); }}
                style={zeilenStyle(gewaehltesMutter?.id === m.id && gewaehltesMutter?.typ === m.typ, m.farbe)}
                onMouseEnter={(e) => { if (gewaehltesMutter?.id !== m.id) e.currentTarget.style.backgroundColor = '#fafafa'; }}
                onMouseLeave={(e) => { if (gewaehltesMutter?.id !== m.id) e.currentTarget.style.backgroundColor = 'transparent'; }}
              >
                {m.farbe && (
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: m.farbe, flexShrink: 0 }} />
                )}
                <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.name}</span>
                <span style={{ fontSize: '10px', color: '#c4c4c4', flexShrink: 0 }}>{typLabel(m.typ)} ›</span>
              </div>
            ))}
          </div>

          <div style={{ ...spalteStyle, borderRight: '1px solid #f0f0ee' }}>
            <div style={{ padding: '8px 12px', fontSize: '10px', fontWeight: '600', color: '#c4c4c4', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #f0f0ee' }}>
              Projekt
            </div>
            {!gewaehltesMutter ? (
              <p style={{ fontSize: '12px', color: '#c4c4c4', padding: '12px', margin: 0 }}>← Bereich wählen</p>
            ) : projekte.length === 0 ? (
              <p style={{ fontSize: '12px', color: '#c4c4c4', padding: '12px', margin: 0 }}>Keine Projekte</p>
            ) : (
              projekte.map(p => (
                <div
                  key={p.id}
                  onClick={() => setGewaehltessProjekt(p)}
                  style={zeilenStyle(gewaehltessProjekt?.id === p.id, gewaehltesMutter?.farbe)}
                  onMouseEnter={(e) => { if (gewaehltessProjekt?.id !== p.id) e.currentTarget.style.backgroundColor = '#fafafa'; }}
                  onMouseLeave={(e) => { if (gewaehltessProjekt?.id !== p.id) e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</span>
                  <span style={{ fontSize: '10px', color: '#c4c4c4', flexShrink: 0 }}>›</span>
                </div>
              ))
            )}
          </div>

          <div style={{ ...spalteStyle, borderRight: 'none' }}>
            <div style={{ padding: '8px 12px', fontSize: '10px', fontWeight: '600', color: '#c4c4c4', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #f0f0ee' }}>
              Task
            </div>
            {!gewaehltessProjekt ? (
              <p style={{ fontSize: '12px', color: '#c4c4c4', padding: '12px', margin: 0 }}>← Projekt wählen</p>
            ) : tasks.length === 0 ? (
              <p style={{ fontSize: '12px', color: '#c4c4c4', padding: '12px', margin: 0 }}>Keine Tasks</p>
            ) : (
              tasks.map(t => (
                <div
                  key={t.id}
                  onClick={() => auswaehlen(t, gewaehltessProjekt, gewaehltesMutter)}
                  style={zeilenStyle(selectedTaskId === t.id, gewaehltesMutter?.farbe)}
                  onMouseEnter={(e) => { if (selectedTaskId !== t.id) e.currentTarget.style.backgroundColor = '#fafafa'; }}
                  onMouseLeave={(e) => { if (selectedTaskId !== t.id) e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.name}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskDropdown;